import { X } from "lucide-react";

export default function Modal({ title, onClose, children, testid }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid={testid || "modal"}>
      <div className="absolute inset-0 bg-[#2A1810]/50" onClick={onClose} data-testid="modal-backdrop" />
      <div className="relative bg-white rounded-xl border border-[#E8DFD1] shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#F4EFEA] sticky top-0 bg-white rounded-t-xl">
          <h3 className="font-display text-lg font-semibold text-[#1C100B]">{title}</h3>
          <button onClick={onClose} data-testid="modal-close-button" className="p-1.5 rounded-lg hover:bg-[#FAF6F0] text-[#8C7A6B]">
            <X size={18} />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export const inputCls =
  "w-full bg-white border border-[#E8DFD1] focus:border-[#C5A059] focus:ring-2 focus:ring-[#C5A059]/20 rounded-lg px-3.5 py-2.5 text-sm text-[#1C100B] placeholder-[#8C7A6B] outline-none transition-colors";

export const btnPrimary =
  "bg-[#2A1810] hover:bg-[#3D2314] text-[#FDFBF7] px-4 py-2.5 rounded-lg font-semibold text-sm transition-colors shadow-sm flex items-center gap-2 disabled:opacity-50";

export const btnSecondary =
  "bg-[#FAF6F0] hover:bg-[#F4EFEA] text-[#2A1810] border border-[#E8DFD1] px-4 py-2.5 rounded-lg font-medium text-sm transition-colors";

export function Field({ label, children, testid }) {
  return (
    <label className="block" data-testid={testid}>
      <span className="block text-xs font-semibold tracking-wider uppercase text-[#8C7A6B] mb-1.5">{label}</span>
      {children}
    </label>
  );
}
